const updateGymsList = (state, { payload }) => {
	state.gymsList = payload;
};

export default updateGymsList;
